export enum AnalyticsType {
  EventSelect = 'EVENT_SELECT',

  PoiClick = 'POI_CLICK',

  LoadingScreenStart = 'LOADING_SCREEN_START',
  LoadingScreenFinish = 'LOADING_SCREEN_FINISH',

  PurewebConnectionStart = 'PUREWEB_CONNECTION_START',
  PurewebConnectionFinish = 'PUREWEB_CONNECTION_FINISH',

  AvatarCustomize = 'AVATAR_CUSTOMIZE',
  AvatarCustomizeFinish = 'AVATAR_CUSTOMIZE_FINISH',
  AvatarCustomizeExit = 'AVATAR_CUSTOMIZE_EXIT',
  AvatarCreateGeneric = 'AVATAR_CREATE_GENERIC',
  AvatarCreateCustom = 'AVATAR_CREATE_CUSTOM',

  AvatarTakePhotos = 'AVATAR_TAKE_PHOTOS',
  AvatarUploadPhotos = 'AVATAR_UPLOAD_PHOTOS',

  AvatarSelectExisting = 'AVATAR_SELECT_EXISTING',

  InputDevicePermissionsPrompt = 'INPUT_DEVICE_PERMISSIONS_PROMPT',
  InputDevicePermissionsAccept = 'INPUT_DEVICE_PERMISSIONS_ACCEPT',
  InputDevicePermissionsDeny = 'INPUT_DEVICE_PERMISSIONS_DENY',

  TeleportToWorldClick = 'TELEPORT_TO_WORLD_CLICK',

  FinishGameLiftStreamsInit = 'FINISH_GAMELIFT_STREAMS_INIT',
  StartGameLiftStreamsInit = 'START_GAMELIFT_STREAMS_INIT',

  StartUeInitialization = 'START_UE_INITIALIZATION',
  FinishUeInitialization = 'FINISH_UE_INITIALIZATION',

  Login = 'LOGIN',
  LogoutClick = 'LOGOUT_CLICK',

  MicOn = 'MIC_ON',
  MicOff = 'MIC_OFF',

  CameraOn = 'CAMERA_ON',
  CameraOff = 'CAMERA_OFF',
  CameraShareStart = 'CAMERA_SHARE_START',
  CameraShareFinish = 'CAMERA_SHARE_FINISH',

  ScreenShareStart = 'SCREEN_SHARE_START',
  ScreenShareFinish = 'SCREEN_SHARE_FINISH',

  OfficeHoursModalUpcomingOpen = 'OFFICE_HOURS_MODAL_UPCOMING_OPEN',
  OfficeHoursModalScheduledOpen = 'OFFICE_HOURS_MODAL_SCHEDULED_OPEN',

  ChatOpen = 'CHAT_OPEN',

  TeleportModalOpen = 'TELEPORT_MODAL_OPEN',
  TeleportModalClose = 'TELEPORT_MODAL_CLOSE',
  TeleportToRegion = 'TELEPORT_TO_REGION',

  JoinedToRegion = 'JOINED_TO_REGION',
  LeftRegion = 'LEFT_REGION',

  CloseBrowserTab = 'CLOSE_BROWSER_TAB',

  ViewPrivacyPolicy = 'VIEW_PRIVACY_POLICY',
  AcceptTerms = 'ACCEPT_TERMS',
  FeedbackSurveyCompleted = 'FEEDBACK_SURVEY_COMPLETED',
  FeedbackSurveyAnswer = 'FEEDBACK_SURVEY_ANSWER',
  EventBookingCreate = 'EVENT_BOOKING_CREATE',
  EventBookingCancel = 'EVENT_BOOKING_CANCEL',

  ToggleVirtualAssistant = 'TOGGLE_VIRTUAL_ASSISTANT',

  ToggleReaction = 'TOGGLE_REACTION',

  EventSessionCrash = 'EVENT_SESSION_CRASH',
  EventSessionTimeout = 'EVENT_SESSION_TIMEOUT',
  EventSessionIssue = 'EVENT_SESSION_ISSUE',
  EventSessionDurationLimit = 'EVENT_SESSION_DURATION_LIMIT',

  NavbarButtonClick = 'NAVBAR_BUTTON_CLICK',

  TeleportToEventStart = 'TELEPORT_TO_EVENT_START',
  TeleportToEventFinish = 'TELEPORT_TO_EVENT_FINISH',
}
